export const toggleMiniCart = () => {
    const sidebarCart = document.querySelector('.sidebar-cart');

    const isCart = document.querySelector('.woocommerce-cart');
    const isCheckout = document.querySelector('.woocommerce-checkout');

    if (sidebarCart !== null && isCart === null && isCheckout === null) {


        const closeSidebarsOverlay = document.querySelector('.close-sidebars-overlay');

        const headerCartOpen = document.querySelectorAll('.headerCart');

        const innerSidebarClose = document.querySelectorAll('.sidebar-cart__close');

        let cartIsOpened = false;

        const openSidebarCart = () => {
            sidebarCart.classList.add('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.add('close-sidebars-overlay--opened');
            document.body.classList.add('overflow-hidden');
            cartIsOpened = true;
        };

        const closeSidebarCart = () => {
            sidebarCart.classList.remove('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.remove('close-sidebars-overlay--opened');
            document.body.classList.remove('overflow-hidden');
            cartIsOpened = false;
        };

        headerCartOpen.forEach(open => {
            open.addEventListener('click', function (e) {
                e.preventDefault();
                openSidebarCart();
            });
        })

        const refreshCartFragment = () => {
            $(document.body).trigger('wc_fragment_refresh');
        };


        innerSidebarClose.forEach(close => {
            close.addEventListener('click', closeSidebarCart);
        });

        document.body.addEventListener('click', function (event) {
            if (event.target.matches('.sidebar-cart__close')) {
                 closeSidebarCart();
            }
        });


        closeSidebarsOverlay.addEventListener('click', closeSidebarCart);


        $(document.body).on('added_to_cart', function () {
            if (cartIsOpened) {
                return;
            }

            refreshCartFragment();
            $(document.body).on('wc_fragments_refreshed', () => {
                openSidebarCart();
                let cartHideTimeout;


                if (window.settings.hasOwnProperty('cart_hide_time') && window.settings.cart_hide_time) {

                    clearTimeout(cartHideTimeout);

                    cartHideTimeout = setTimeout(() => {
                        closeSidebarCart();
                    }, window.settings.cart_hide_time);

                    $('.sidebar-cart__scroll').on('scroll', () => {
                        clearTimeout(cartHideTimeout);
                    });
                }

            });


        });

    }


}